import React from 'react'
import {
  SimpleForm,
  TextInput,
  SelectInput,
  NumberInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin'
import { Create as CreateWrapper } from '../common/views'
import RichTextInput from '../common/inputs/RichTextInput'
import { directoryTypeChoices, industryTypeChoices } from './constants'

const LeadDirectoryCreate = (props) => (
  <CreateWrapper {...props}>
    <SimpleForm>
      <TextInput
        source="name"
        label="Name"
        fullWidth
        required
        validate={(value) => (!value ? 'Name is required' : undefined)}
      />
      <TextInput
        source="site"
        label="Site URL"
        type="url"
        fullWidth
        required
        validate={(value) => (!value ? 'Site is required' : undefined)}
      />
      <TextInput
        source="description"
        label="Description"
        fullWidth
        multiline
        rows="3"
      />
      <RichTextInput
        source="guide"
        label="Guide for Analyzing Leads"
        fullWidth
      />
      <TextInput
        source="tags"
        label="Tags (comma-separated)"
        placeholder="b2b, tech, saas"
        fullWidth
      />
      <SelectInput
        source="industry"
        label="Industry"
        choices={industryTypeChoices}
        fullWidth
      />
      <SelectInput
        source="type"
        label="Type"
        choices={directoryTypeChoices}
        fullWidth
        required
        validate={(value) => (!value ? 'Type is required' : undefined)}
      />
      <NumberInput
        source="estimated_leads_count"
        label="Estimated Leads Count"
        fullWidth
      />
      <ReferenceInput
        source="recommended_campaign_id"
        reference="campaigns"
        label="Recommended Campaign"
        fullWidth
      >
        <AutocompleteInput optionText="name" optionValue="id" />
      </ReferenceInput>
    </SimpleForm>
  </CreateWrapper>
)

export default LeadDirectoryCreate
